<template>
    <span
        v-if="parts.length > 1"
        class="uapz09"
    >
        <span
            class="whitespace-nowrap"
            v-html="stringStart + '&nbsp;'"
        /><template
            v-for="(part, i) in parts"
            :key="part.imageKod"
        >
            {{ i === 0 ? "" : "&nbsp;/&nbsp;"
            }}<NuxtLink
                :to="
                    localePath(
                        `/texty/${part.knihaKod}/${part.temaKod}#figura-${part.imageKod.replaceAll('.', '-')}`
                    )
                "
                >{{ part.origin }}</NuxtLink
            ></template
        >)</span
    ><NuxtLink
        v-else-if="parts[0]"
        :to="
            localePath(
                `/texty/${parts[0].knihaKod}/${parts[0].temaKod}#figura-${parts[0].imageKod.replaceAll('.', '-')}`
            )
        "
    >
        <span
            class="whitespace-nowrap"
            v-html="stringStart + '&nbsp;'"
        />{{ parts[0].origin }})</NuxtLink
    >
</template>

<script lang="ts" setup>
const localePath = useLocalePath()
const props = defineProps<{
    html: string
}>()
const route = useRoute()

const formattedHtml = props.html
    .replace(/&nbsp;/g, " ")
    .replace(/<span class="uapz09">(.*?)<\/span>/g, "$1")

const stringStart = formattedHtml
    .split(/ \d/)[0]
    ?.replaceAll(" ", "&nbsp;")
    .replaceAll("", "<i class='pi pi-arrow-right text-sm'></i>")
    .replaceAll("→", "<i class='pi pi-arrow-right text-sm'></i>")
    .replaceAll("🡪", "<i class='pi pi-arrow-right text-sm'></i>")
    .replaceAll(
        "<i&nbsp;class='pi&nbsp;pi-arrow-right&nbsp;text-sm'></i>",
        "<i class='pi pi-arrow-right text-sm'></i>"
    )
/* if (!stringStart?.startsWith("(<i class='pi pi-arrow-right text-sm'></i>")) {
    stringStart = "(<i class='pi pi-arrow-right text-sm'></i>" + stringStart
} */

const kod = formattedHtml.match(/\d\.?( ?(\/|,) ?)?/g)?.join("")
type Codes = {
    origin: string
    knihaKod: string
    temaKod: string
    imageKod: string
}
const parts = ref<Codes[]>([])
const codes = kod?.split(/ ?(\/|,) ?/g)
codes?.forEach(code => {
    if (code === "/") return
    parts.value.push(getImagePart(code))
})

function getImagePart(code: string) {
    const codeParts = code.split(".")
    //check if image is form another book
    const knihaKod =
        (codeParts[0] as string).length > 2
            ? (codeParts[0] as string)
            : (route.params.kody?.[0] as string)
    const imageKod =
        (codeParts[0] as string) === knihaKod
            ? codeParts.join(".")
            : knihaKod + "." + codeParts.join(".")
    const temaKod = imageKod
        .split(".")
        .slice(1, imageKod.split(".").length - 1)
        .join(".")
    return { origin: code, knihaKod, temaKod, imageKod }

    /* const imageKod =
        code.split(".").length === 5 ||
        (locale.value === "en" &&
            (code.split(".").length === 4 || code.split(".").length === 3))
            ? code?.split(".").slice(1).join(".")
            : code
    const knihaKod =
        code.split(".").length === 5 ||
        (locale.value === "en" &&
            (code.split(".").length === 4 || code.split(".").length === 3))
            ? (code.split(".")[0] as string)
            : ((route.params.kody as string[])[0] as string)
    const temaKod = imageKod.substring(0, imageKod.lastIndexOf("."))
    return { origin: code, knihaKod, temaKod, imageKod } */
}
</script>

<style scoped></style>
